export async function sleep(
  duration: Temporal.Duration,
  signal?: AbortSignal,
): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    if (signal?.aborted) {
      reject(signal.reason);
      return;
    }
    const timeout = setTimeout(() => {
      resolve();
      signal?.removeEventListener("abort", abort);
    }, duration.total("milliseconds"));
    const abort = () => {
      clearTimeout(timeout);
      reject(signal!.reason);
    };
    signal?.addEventListener("abort", abort);
  });
}
